import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { RechazosTracesParteIViewModel, TNTRetrievalAttachmentViewModel } from '../rechazostraces.types';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';

@Component({
    selector: 'app-rechazostraces-parte-i',
    templateUrl: './rechazostraces-parte-i.component.html',
})
export class RechazosTracesParteIComponent extends ComponentBase implements OnInit, OnChanges {
    @Input() formGroup: FormGroup;
    @Input() tracesParteI: RechazosTracesParteIViewModel;
    @Input() isRechazo = false;
    @Output() download = new EventEmitter<any | null>();

    public isCollapsedExportador = false;
    public isCollapsedImportador = false;
    public isCollapsedDocAduanero = false;
    public isCollapsedCHEDPP = false;
    public isCollapsedPCF = false;
    public isCollapsedOperador = false;
    public isCollapsedDocAcomp = false;
    public isCollapsedNotPrev = false;
    public isCollapsedLugarDestino = false;
    public isCollapsedMedioTrans = false;
    public isCollapsedPaisOrigen = false;
    public isCollapsedPaisExpedicion = false;
    public isCollapsedRegionOrigen = false;
    public isCollapsedNumeroContenedor = false;
    public isCollapsedFinalidad = false;
    public isCollapsedEmbalajes = false;
    public isCollapsedProductos = false;

    numeroDocumentos = 0;
    numeroEmbalajes = 0;
    numeroProductos = 0;

    colsDocumentos: any[];
    colsEmbalajes: any[];
    colsProductos: any[];

    dateToString: string;

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        //protected rechazosTracesService: RechazosTracesService,
        public datepipe: DatePipe,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.colsDocumentos = [
            { field: 'Nombre', header: 'Nombre' },
            { field: 'Numero', header: 'Número' },
            { field: 'Fecha', header: 'Fecha' },
            { field: 'Pais', header: 'País' },
            { field: 'Tipo', header: 'Tipo' },
            { field: 'Link', header: 'Link' },
        ];

        this.colsEmbalajes = [
            { field: 'Taric', header: 'Código TARIC' },
            { field: 'Eppo', header: 'Código EPPO' },
            { field: 'NombreComun', header: 'Nombre común' },
            { field: 'Peso', header: 'Peso' },
            { field: 'Recuento', header: 'Recuento' },
            { field: 'PaisOrigen', header: 'País de origen' },
        ];

        this.colsProductos = [
            { field: 'Taric', header: 'Código TARIC' },
            { field: 'Eppo', header: 'Código EPPO' },
            { field: 'NombreComun', header: 'Nombre común' },
            { field: 'NombreCientifico', header: 'Nombre científico' },
            { field: 'Tipo', header: 'Tipo' },
            { field: 'Peso', header: 'Peso' },
            { field: 'Volumen', header: 'Volumen' },
            { field: 'NumeroUnidades', header: 'Recuento de bultos' },
            { field: 'NumeroBultos', header: 'Cantidad' },
            { field: 'PaisOrigen', header: 'País de origen' },
        ];

        this.updateForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // Verificar si el objeto de referencia tiene un valor actual en los cambios
        if (changes?.['tracesParteI']?.currentValue) {
            this.dateToString = this.tracesParteI?.NotificacionPrevia?.toLocaleString();

            this.updateForm();

            // Procesar los documentos y habilitar el botón de descarga
            this.tracesParteI?.Documentos.forEach(res => {
                this.onCheckEnableDownloadButtonAvailable(res);
            });

            // Actualizar los contadores
            this.numeroDocumentos = this.tracesParteI?.Documentos.length;
            this.numeroEmbalajes = this.tracesParteI?.Embalajes.length;
            this.numeroProductos = this.tracesParteI?.Productos.length;
        }
    }

    private updateForm(): void {
        this.formGroup.patchValue({
            NombreExportador: this.tracesParteI?.NombreExportador,
            PaisExportador: this.tracesParteI?.PaisExportador,
            NombreImportador: this.tracesParteI?.NombreImportador,
            PaisImportador: this.tracesParteI?.PaisImportador,
            RefDocAduanero: this.tracesParteI?.RefDocAduanero,
            Referencia: this.tracesParteI?.Referencia,
            //NombrePCF: this.tracesParteI?.NombrePCF,
            //PaisPCF: this.tracesParteI?.PaisPCF,
            NombrePIF: this.tracesParteI?.NombrePIF,
            PaisPIF: this.tracesParteI?.PaisPIF,
            NombreOperador: this.tracesParteI?.NombreOperador,
            PaisOperador: this.tracesParteI?.PaisOperador,
            Documentos: this.tracesParteI?.Documentos,
            NotificacionPrevia: this.datepipe.transform(this.tracesParteI?.NotificacionPrevia, 'dd/MM/yyyy'),
            NombreLugarDestino: this.tracesParteI?.NombreLugarDestino,
            PaisLugarDestino: this.tracesParteI?.PaisLugarDestino,
            NombreMedioTrans: this.tracesParteI?.NombreMedioTrans,
            TipoMedioTrans: this.tracesParteI?.TipoMedioTrans,
            PaisMedioTrans: this.tracesParteI?.PaisMedioTrans,
            DocumentoMedioTrans: this.tracesParteI?.DocumentoMedioTrans,
            PaisOrigen: this.tracesParteI?.PaisOrigen,
            PaisExpedicion: this.tracesParteI?.PaisExpedicion,
            NumeroContenedor: this.tracesParteI?.NumeroContenedor,
            NumeroPrecinto: this.tracesParteI?.NumeroPrecinto,
            PrecintoOficial: this.tracesParteI?.PrecintoOficial,
            Finalidad: this.tracesParteI?.Finalidad,
            Embalajes: this.tracesParteI?.Embalajes,
            Productos: this.tracesParteI?.Productos,
        });

        this.form = this.formGroup;
    }

    onDownload(item: any): void {
        let model = new TNTRetrievalAttachmentViewModel();
        let id = item?.Link;

        model.CHEDPP = this.tracesParteI.CHEDPP;

        if (model.CHEDPP.charAt(model.CHEDPP.length - 1) === 'R') {
            model.CHEDPP = model.CHEDPP.slice(0, -1);
        }

        model.DocumentId = Number(id);
        model.FileName = item.Nombre;

        this.download.emit(model);
    }

    onCheckEnableDownloadButtonAvailable(item: any): void {
        let model = new TNTRetrievalAttachmentViewModel();
        let id = item?.Link;

        model.DocumentId = Number(id);

        if (model.DocumentId === 0 || Number.isNaN(model.DocumentId)) {
            item.DownloadButtonAvailable = false;
        }
    }
}
